<template>
    <div id="dashboard" class="container-fluid px-0 permisos-page">
        <section class="ps-lg-4 pe-lg-4 pb-4">
            <div class="permisos-formulario">
                <header id="seccionCabecera" class="permisos-cabecera">
                    <div class="permisos-cabecera-fila">
                        <p class="permisos-title-row">
                            <span id="cabeceraDashboard" class="permisos-title">{{ $t('dashboardUsers') }}</span>
                        </p>
                        <button
                            type="button"
                            class="btn permisos-alta-toggle"
                            :class="{ abierta: altaAbierta }"
                            :aria-expanded="altaAbierta ? 'true' : 'false'"
                            aria-controls="permisos-alta-panel"
                            @click="alternarAlta"
                        >
                            <span class="fas fa-plus permisos-alta-toggle-icono" aria-hidden="true"></span>
                            <span class="permisos-alta-toggle-textos">
                                <span :class="{ 'es-oculto': altaAbierta }" :aria-hidden="altaAbierta ? 'true' : 'false'">Nuevo usuario</span>
                                <span :class="{ 'es-oculto': !altaAbierta }" :aria-hidden="altaAbierta ? 'false' : 'true'">Cerrar</span>
                            </span>
                        </button>
                    </div>
                    <p class="permisos-lead">
                        Panel de gestion de usuarios y permisos.
                    </p>
                </header>

                <div id="permisos-alta-panel" class="permisos-alta-panel" :class="{ abierta: altaAbierta }">
                    <div class="permisos-alta-panel-interior">
                        <section class="permisos-sheet" aria-labelledby="permisos-alta-titulo">
                            <h2 id="permisos-alta-titulo" class="permisos-bloque-titulo">Nuevo usuario</h2>
                            <form class="permisos-alta" @submit.prevent="guardar">
                                <div class="permisos-alta-correo">
                                    <label for="permisos-alta-email" class="permisos-label">Correo</label>
                                    <input
                                        id="permisos-alta-email"
                                        ref="altaEmail"
                                        v-model.trim="newUser.email"
                                        type="email"
                                        class="form-control"
                                        autocomplete="off"
                                        :placeholder="$t('registerEmail')"
                                    >
                                </div>
                                <div class="permisos-alta-accion">
                                    <button type="submit" class="btn permisos-commit" :disabled="creando || !newUser.email">
                                        Crear usuario
                                    </button>
                                </div>
                                <div class="permisos-alta-indicadores" role="group" aria-label="Indicadores">
                                    <button
                                        v-for="indicador in indicadores"
                                        :key="'alta-' + indicador.campo"
                                        type="button"
                                        class="permisos-toma permisos-toma-indicador"
                                        role="switch"
                                        :aria-checked="Number(newUser[indicador.campo]) === 1 ? 'true' : 'false'"
                                        @click="cambiarNew(indicador.tipo)"
                                    >
                                        <span class="permisos-toma-texto">
                                            <span class="permisos-toma-nombre">{{ indicador.nombre }}</span>
                                            <span class="permisos-toma-ayuda">{{ indicador.ayuda }}</span>
                                        </span>
                                        <span class="permisos-switch" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </form>
                            <p v-if="altaError" class="permisos-error" role="alert">{{ altaError }}</p>
                            <p class="permisos-nota">El usuario se creara sin permisos de lectura ni permisos para envio de comunicaciones o gestion de listas de destinatarios. Al crear el usuario se abrirá un modal para concederle permisos.</p>
                        </section>
                    </div>
                </div>

                <section class="permisos-roster" aria-labelledby="permisos-roster-titulo">
                    <header class="permisos-roster-head">
                        <div>
                            <h2 id="permisos-roster-titulo" class="permisos-bloque-titulo mb-0">{{ cuentaUsuarios }}</h2>
                        </div>
                        <div class="permisos-buscar">
                            <label for="permisos-buscar" class="visually-hidden">Buscar por correo</label>
                            <span class="fas fa-search permisos-buscar-icono" aria-hidden="true"></span>
                            <input
                                id="permisos-buscar"
                                v-model.trim="filtro"
                                type="search"
                                class="form-control"
                                placeholder="Buscar por correo"
                                autocomplete="off"
                            >
                        </div>
                    </header>

                    <p v-if="listaError" class="permisos-error" role="alert">{{ listaError }}</p>

                    <div class="permisos-tabla-wrap">
                        <table class="permisos-tabla">
                            <thead>
                                <tr>
                                    <th scope="col">Correo</th>
                                    <th v-for="indicador in indicadores" :key="'th-' + indicador.campo" scope="col" class="permisos-th-indicador">
                                        {{ indicador.nombre }}
                                    </th>
                                    <th scope="col" class="permisos-th-accion"><span class="visually-hidden">Acciones</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="cargado && usuariosVisibles.length === 0">
                                    <td :colspan="indicadores.length + 2" class="permisos-nadie">
                                        <template v-if="filtro">Ningún correo contiene «{{ filtro }}».</template>
                                        <template v-else>Todavía no hay usuarios declarados. Da de alta el primero arriba.</template>
                                    </td>
                                </tr>
                                <tr
                                    v-for="item in usuariosVisibles"
                                    :key="item.email"
                                    :class="{ 'es-ficha': fichaAbierta && emailFicha === item.email }"
                                >
                                    <th scope="row" class="permisos-email">
                                        <span class="permisos-email-local">{{ partesEmail(item.email).local }}</span><span class="permisos-email-dominio">{{ partesEmail(item.email).dominio }}</span>
                                    </th>
                                    <td
                                        v-for="indicador in indicadores"
                                        :key="item.email + '-' + indicador.campo"
                                        class="permisos-td-indicador"
                                        :data-label="indicador.nombre"
                                    >
                                        <button
                                            type="button"
                                            class="permisos-switch-boton"
                                            role="switch"
                                            :aria-checked="Number(item[indicador.campo]) === 1 ? 'true' : 'false'"
                                            :aria-label="indicador.nombre + ' de ' + item.email"
                                            @click="cambiar(item, indicador.tipo)"
                                        >
                                            <span class="permisos-switch" aria-hidden="true"></span>
                                        </button>
                                    </td>
                                    <td class="permisos-td-acciones">
                                        <div class="permisos-acciones">
                                            <button type="button" class="btn permisos-abrir" @click="elegir(item)">
                                                Lectura y orígenes
                                            </button>
                                            <button
                                                type="button"
                                                class="btn permisos-borrar"
                                                :aria-label="'Borrar a ' + item.email"
                                                title="Borrar usuario"
                                                @click="activaModal(item)"
                                            >
                                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </section>

        <BModal
            v-model="fichaAbierta"
            size="lg"
            centered
            scrollable
            modal-class="permisos-modal"
            header-close-label="Cerrar"
        >
            <template #title>
                <span class="permisos-modal-eyebrow">Lectura y orígenes</span>
                <span class="permisos-modal-email">{{ emailFicha }}</span>
            </template>

            <p v-if="!fichaCargada && !fichaError" class="permisos-vacio">Cargando la ficha…</p>
            <p v-else-if="!fichaCargada" class="permisos-error mt-0" role="alert">{{ fichaError }}</p>

            <template v-else>
                <section class="permisos-bloque" aria-labelledby="permisos-lectura-titulo">
                    <header class="permisos-bloque-cabeza">
                        <h3 id="permisos-lectura-titulo" class="permisos-bloque-nombre">Panel de incidencias</h3>
                        <p class="permisos-bloque-ayuda">Qué incidencias ve en los cuadros, el detalle y el buscador.</p>
                    </header>
                    <p v-if="catalogoDominios.length === 0" class="permisos-vacio">El catálogo de dominios está vacío.</p>
                    <div v-else class="permisos-dominios">
                        <button
                            v-for="codigo in catalogoDominiosOrdenados"
                            :key="'dominio-' + codigo"
                            type="button"
                            class="permisos-toma"
                            role="switch"
                            :aria-checked="concedido('dominio', codigo) ? 'true' : 'false'"
                            :aria-label="'Leer ' + etiquetaDominio(codigo)"
                            @click="cambiarConcesion('dominio', codigo)"
                        >
                            <span class="permisos-codigo">{{ etiquetaDominio(codigo) }}</span>
                            <span class="permisos-switch" aria-hidden="true"></span>
                        </button>
                    </div>
                    <p v-if="catalogoDominios.length > 0 && dominios.length === 0" class="permisos-aviso">
                        Sin lectura no verá ninguna incidencia.
                    </p>
                </section>

                <section class="permisos-bloque" aria-labelledby="permisos-origenes-titulo">
                    <header class="permisos-bloque-cabeza">
                        <h3 id="permisos-origenes-titulo" class="permisos-bloque-nombre">Orígenes</h3>
                        <p class="permisos-bloque-ayuda">Por qué formulario envía y de qué origen edita las listas de destinatarios.</p>
                    </header>
                    <p v-if="catalogoOrigenes.length === 0" class="permisos-vacio">El catálogo de orígenes está vacío.</p>
                    <ul v-else class="permisos-origenes">
                        <li
                            v-for="codigo in catalogoOrigenes"
                            :key="'origen-' + codigo"
                            class="permisos-origen"
                            :class="{
                                'con-listas': concedido('listas', codigo),
                                'con-envio': concedido('envio', codigo),
                                'arrastre-previsto': previo.codigo === codigo && (seArrastra('envio', codigo) || seArrastra('listas', codigo))
                            }"
                        >
                            <span class="permisos-codigo">{{ codigo }}</span>
                            <button
                                type="button"
                                class="permisos-toma"
                                :class="{ 'se-arrastra': seArrastra('envio', codigo) }"
                                role="switch"
                                :aria-checked="concedido('envio', codigo) ? 'true' : 'false'"
                                :aria-label="'Enviar por ' + codigo"
                                @click="cambiarConcesion('envio', codigo)"
                                @mouseenter="preveer('envio', codigo)"
                                @mouseleave="preveer('', '')"
                                @focus="preveer('envio', codigo)"
                                @blur="preveer('', '')"
                            >
                                <span class="permisos-toma-nombre">Enviar comunicación</span>
                                <span class="permisos-switch" aria-hidden="true"></span>
                            </button>
                            <span class="permisos-conector" aria-hidden="true"></span>
                            <button
                                type="button"
                                class="permisos-toma"
                                :class="{ 'se-arrastra': seArrastra('listas', codigo) }"
                                role="switch"
                                :aria-checked="concedido('listas', codigo) ? 'true' : 'false'"
                                :aria-label="'Editar listas de ' + codigo"
                                @click="cambiarConcesion('listas', codigo)"
                                @mouseenter="preveer('listas', codigo)"
                                @mouseleave="preveer('', '')"
                                @focus="preveer('listas', codigo)"
                                @blur="preveer('', '')"
                            >
                                <span class="permisos-toma-nombre">Listas comunicación</span>
                                <span class="permisos-switch" aria-hidden="true"></span>
                            </button>
                        </li>
                    </ul>
                    <p class="permisos-nota">
                        Dar las listas de un origen da también su envío. Quitar el envío quita las listas; quitar las listas deja el envío.
                    </p>
                </section>
            </template>

            <template #footer>
                <p class="permisos-estado" :class="{ 'es-error': fichaCargada && fichaError }" aria-live="polite">{{ estadoFicha }}</p>
                <button type="button" class="btn permisos-commit" @click="fichaAbierta = false">Cerrar</button>
            </template>
        </BModal>

        <BModal
            v-model="modalBorrado"
            title="Borrar usuario"
            centered
            modal-class="permisos-modal permisos-modal-peligro"
            ok-title="Borrar usuario"
            ok-variant="danger"
            cancel-title="Cancelar"
            cancel-variant="outline-secondary"
            header-close-label="Cerrar"
            @ok="borrar(emailBorrado)"
        >
            <p class="mb-2">Vas a borrar a <strong>{{ emailBorrado }}</strong> junto con su lectura y sus orígenes.</p>
            <p class="permisos-nota mb-0">
                Si vuelve a entrar por la organización será un usuario no declarado: leerá todos los dominios y no enviará.
            </p>
        </BModal>
    </div>
</template>

<script>
import auth from '../auth.js';
import {BModal} from "bootstrap-vue-next";
import accesoEfectivoModulo from '../../envio-sms/accesoEfectivo.js';

const {aplicarArrastre, concederLectura} = accesoEfectivoModulo;

class User {
    constructor(email, editor, admin, consultor_errores) {
        this.email = email;
        this.editor = editor;
        this.admin = admin;
        this.consultor_errores = consultor_errores;
    }
}

const INDICADORES = [
    {campo: 'editor', tipo: 1, nombre: 'Edición', ayuda: 'Modificacion y borrado de incidencias'},
    {campo: 'admin', tipo: 0, nombre: 'Administración', ayuda: 'Gestion de usuarios y permisos'},
    {campo: 'consultor_errores', tipo: 2, nombre: 'Errores', ayuda: 'Visualiza el panel de errores'}
];

function indicadorDeTipo(type) {
    return INDICADORES.find(i => i.tipo === type);
}

function mensajeDe(data, porDefecto) {
    const texto = data && data.resultado ? String(data.resultado).replace(/^Error:\s*/i, '') : '';
    if (!texto) return porDefecto;
    return texto.charAt(0).toUpperCase() + texto.slice(1) + '.';
}

export default {
	components: {BModal},
    data(){
        return {
            indicadores: INDICADORES,
            newUser: new User('', 0, 0, 0),
            conjuntoUsers: [],
            cargado: false,
            filtro: '',
            listaError: '',
            creando: false,
            altaError: '',
            altaAbierta: false,
            modalBorrado: false,
            emailBorrado: '',
            fichaAbierta: false,
            fichaCargada: false,
            emailFicha: '',
            catalogoDominios: [],
            catalogoOrigenes: [],
            dominios: [],
            origenesEnvio: [],
            origenesListas: [],
            fichaError: '',
            guardando: 0,
            guardado: false,
            previo: {tipo: '', codigo: ''},
            concesionCola: Promise.resolve()
        }
    },
    computed: {
        usuariosVisibles() {
            const filtro = this.filtro.toLowerCase();
            if (!filtro) return this.conjuntoUsers;
            return this.conjuntoUsers.filter(u => String(u.email).toLowerCase().indexOf(filtro) !== -1);
        },
        cuentaUsuarios() {
            if (!this.cargado) return 'Cargando…';
            const total = this.conjuntoUsers.length;
            const nombre = total === 1 ? 'usuario' : 'usuarios';
            if (this.filtro) return this.usuariosVisibles.length + ' de ' + total + ' ' + nombre;
            return total + ' ' + nombre;
        },
        estadoFicha() {
            if (this.fichaCargada && this.fichaError) return this.fichaError;
            if (this.guardando > 0) return 'Guardando…';
            if (this.guardado) return 'Cambios guardados.';
            return 'Cada interruptor se guarda al momento.';
        },
        catalogoDominiosOrdenados() {
            const orden = ['Red', 'ZTE', 'IT'];
            const catalogo = this.catalogoDominios || [];
            const ordenados = [];
            for (let i = 0; i < orden.length; i++) {
                if (catalogo.indexOf(orden[i]) !== -1) ordenados.push(orden[i]);
            }
            for (let i = 0; i < catalogo.length; i++) {
                if (ordenados.indexOf(catalogo[i]) === -1) ordenados.push(catalogo[i]);
            }
            return ordenados;
        }
    },
    created() {
        this.consultarUsers();
        this.$store.state.botonEditar = false;
        this.$store.state.editar = false;
    },
    methods: {
        partesEmail(email) {
            const texto = String(email || '');
            const arroba = texto.indexOf('@');
            if (arroba === -1) return {local: texto, dominio: ''};
            return {local: texto.slice(0, arroba), dominio: texto.slice(arroba)};
        },
        alternarAlta() {
            this.altaAbierta = !this.altaAbierta;
            if (!this.altaAbierta) {
                this.altaError = '';
                return;
            }
            this.$nextTick(() => {
                if (this.$refs.altaEmail) this.$refs.altaEmail.focus({preventScroll: true});
            });
        },
        activaModal(item) {
            this.emailBorrado = item.email;
            this.modalBorrado = true;
        },
        async cambiar(item, type){
            const indicador = indicadorDeTipo(type);
            const campo = indicador.campo;
            const anterior = Number(item[campo]);
            item[campo] = anterior === 0 ? 1 : 0;
            this.listaError = '';
            try {
                const response = await fetch ('/api/users/updateUsuario/',{
                                                method: 'PUT',
                                                headers: auth.getAuthHeader(),
                                                body: JSON.stringify(
                                                    {
                                                        email: item.email,
                                                        editor: item.editor,
                                                        admin: item.admin,
                                                        consultor_errores: item.consultor_errores
                                                    })
                                               }
                                            );
                if (!response.ok) {
                    const data = await response.json().catch(() => null);
                    throw new Error(mensajeDe(data, 'Respuesta ' + response.status));
                }
            }  catch (error) {
                console.error("No se pudieron guardar los cambios de permisos del usuario " + item.email + ":",error);
                item[campo] = anterior;
                this.listaError = 'No se pudo guardar ' + indicador.nombre + ' de ' + item.email + '. Vuelve a intentarlo.';
            }
        },
        cambiarNew(type){
            const campo = indicadorDeTipo(type).campo;
            this.newUser[campo] = Number(this.newUser[campo]) === 0 ? 1 : 0;
        },
        async consultarUsers () {
            try {
                const response = await fetch ('/api/users/usuarios/',{
                                                    method: 'GET',
                                                    headers: auth.getAuthHeader()
                                                    }
                                                );
                const users = await response.json();
                if (!response.ok) {
                    this.conjuntoUsers = [];
                    if (response.status !== 404) {
                        this.listaError = mensajeDe(users, 'No se pudieron consultar los usuarios.');
                    }
                    return;
                }
                this.conjuntoUsers = users.map(user => ({
                    ...user,
                    editor: Number(user.editor),
                    admin: Number(user.admin),
                    consultor_errores: Number(user.consultor_errores)
                }));
            } catch (error) {
                console.error("No se pudieron consultar los usuarios:", error);
                this.listaError = 'No se pudieron consultar los usuarios.';
            } finally {
                this.cargado = true;
            }
        },
        async guardar(){
            const email = String(this.newUser.email || '').trim().toLowerCase();
            if (!email) return;
            this.creando = true;
            this.altaError = '';
            try {
                const response = await fetch ('/api/users/nuevoUsuario/',{
                                                method: 'POST',
                                                headers: auth.getAuthHeader(),
                                                body: JSON.stringify(
                                                    {
                                                        email: email,
                                                        editor: this.newUser.editor,
                                                        admin: this.newUser.admin,
                                                        consultor_errores: this.newUser.consultor_errores
                                                    })
                                               }
                                            );
                const data = await response.json();
                if (!response.ok) {
                    const yaExiste = this.conjuntoUsers.some(u => u.email === email);
                    this.altaError = yaExiste
                        ? email + ' ya está declarado. Búscalo en el listado para cambiar sus permisos.'
                        : mensajeDe(data, 'No se pudo dar de alta a ' + email + '.');
                    return;
                }
                this.newUser = new User('', 0, 0, 0);
                this.altaAbierta = false;
                await this.consultarUsers();
                const nuevo = this.conjuntoUsers.find(u => u.email === email);
                if (nuevo) this.elegir(nuevo);
            }  catch (error) {
                console.error("No se pudo crear el nuevo usuario " + email + ":",error);
                this.altaError = 'No se pudo dar de alta a ' + email + '.';
            } finally {
                this.creando = false;
            }
        },
        async borrar(email){
            this.listaError = '';
            try {
                const response = await fetch ('/api/users/borrarUsuario/',{
                                                method: 'DELETE',
                                                headers: auth.getAuthHeader(),
                                                body: JSON.stringify(
                                                    {
                                                        email: email
                                                    })
                                               }
                                            );
                const data = await response.json();
                if (!response.ok) {
                    this.listaError = mensajeDe(data, 'No se pudo borrar a ' + email + '.');
                    return;
                }
                if (this.emailFicha === email) {
                    this.emailFicha = '';
                    this.fichaAbierta = false;
                }
                await this.consultarUsers();
            }  catch (error) {
                console.error("No se pudo borrar el usuario " + email + ":",error);
                this.listaError = 'No se pudo borrar a ' + email + '.';
            }
        },
        async elegir(item) {
            this.emailFicha = item.email;
            this.fichaError = '';
            this.fichaCargada = false;
            this.guardado = false;
            this.previo = {tipo: '', codigo: ''};
            this.fichaAbierta = true;
            await this.cargarFicha();
        },
        async cargarFicha() {
            if (!this.emailFicha) return;
            const email = this.emailFicha;
            try {
                const response = await fetch('/api/users/concesiones?email=' + encodeURIComponent(email), {
                    method: 'GET',
                    headers: auth.getAuthHeader()
                });
                const data = await response.json();
                if (this.emailFicha !== email) return;
                if (!response.ok) {
                    this.fichaError = mensajeDe(data, 'No se pudo cargar la ficha.');
                    return;
                }
                this.catalogoDominios = data.catalogoDominios || [];
                this.catalogoOrigenes = data.catalogoOrigenes || [];
                this.dominios = data.dominios || [];
                this.origenesEnvio = data.origenesEnvio || [];
                this.origenesListas = data.origenesListas || [];
                this.fichaError = '';
                this.fichaCargada = true;
            } catch (error) {
                console.error('No se pudo cargar la ficha de ' + email, error);
                if (this.emailFicha === email) this.fichaError = 'No se pudo cargar la ficha.';
            }
        },
        aplicarLocal(tipo, codigo, activo) {
            if (tipo === 'dominio') {
                this.dominios = concederLectura({
                    catalogoDominios: this.catalogoDominios,
                    dominios: this.dominios,
                    codigo: codigo,
                    activo: activo
                });
                return;
            }
            const arrastre = aplicarArrastre({
                catalogoOrigenes: this.catalogoOrigenes,
                envio: this.origenesEnvio,
                listas: this.origenesListas,
                tipo: tipo,
                codigo: codigo,
                activo: activo
            });
            this.origenesEnvio = arrastre.envio;
            this.origenesListas = arrastre.listas;
        },
        etiquetaDominio(codigo) {
            if (codigo === 'Red') return 'HUAWEI';
            return codigo;
        },
        concedido(tipo, codigo) {
            if (tipo === 'dominio') return this.dominios.indexOf(codigo) !== -1;
            if (tipo === 'envio') return this.origenesEnvio.indexOf(codigo) !== -1;
            return this.origenesListas.indexOf(codigo) !== -1;
        },
        preveer(tipo, codigo) {
            this.previo = {tipo: tipo, codigo: codigo};
        },
        seArrastra(tipo, codigo) {
            if (this.previo.codigo !== codigo || this.previo.tipo === tipo) return false;
            if (tipo === 'envio') {
                return !this.concedido('listas', codigo) && !this.concedido('envio', codigo);
            }
            if (tipo === 'listas') {
                return this.concedido('envio', codigo) && this.concedido('listas', codigo);
            }
            return false;
        },
        cambiarConcesion(tipo, codigo) {
            const email = this.emailFicha;
            const activo = this.concedido(tipo, codigo) ? 0 : 1;
            this.aplicarLocal(tipo, codigo, activo);
            this.guardando += 1;
            this.concesionCola = this.concesionCola.then(async () => {
                try {
                    const response = await fetch('/api/users/concesion', {
                        method: 'PUT',
                        headers: auth.getAuthHeader(),
                        body: JSON.stringify({
                            email: email,
                            tipo: tipo,
                            codigo: codigo,
                            activo: activo
                        })
                    });
                    const data = await response.json();
                    if (!response.ok || this.emailFicha !== email) {
                        if (this.emailFicha === email) {
                            this.fichaError = mensajeDe(data, 'No se pudo guardar el cambio.');
                            await this.cargarFicha();
                            this.fichaError = this.fichaError || 'No se pudo guardar el cambio.';
                        }
                        return;
                    }
                    this.dominios = data.dominios || [];
                    this.origenesEnvio = data.origenesEnvio || [];
                    this.origenesListas = data.origenesListas || [];
                    this.fichaError = '';
                    this.guardado = true;
                } catch (error) {
                    console.error('No se pudo guardar la concesión de ' + email, error);
                    if (this.emailFicha === email) {
                        await this.cargarFicha();
                        this.fichaError = 'No se pudo guardar el cambio.';
                    }
                } finally {
                    this.guardando -= 1;
                }
            });
        }
    }
}
</script>

<style scoped>
.permisos-page {
    --ink: #1b2740;
    --soft: #5c6b86;
    --line: #d5deea;
    --field: #8b97ab;
    --sheet: #f3f6fa;
    --senal: #ff7900;
    --peligro: #9b1c3c;
    --mono: ui-monospace, "SFMono-Regular", "Cascadia Mono", Menlo, Consolas, monospace;
    margin-top: -0.75rem;
    padding-top: 1.15rem;
    background: #fff;
    color: var(--ink);
}

.permisos-formulario {
    max-width: 72rem;
    margin-left: auto;
    margin-right: auto;
}

.permisos-cabecera {
    margin-bottom: 1.15rem;
}

.permisos-cabecera-fila {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem 1.25rem;
    margin-top: 1rem;
}

.permisos-formulario #seccionCabecera .permisos-title-row {
    margin-top: 0;
}

/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */
.permisos-alta-toggle-textos {
    display: inline-grid;
}

.permisos-alta-toggle-textos > span {
    grid-area: 1 / 1;
    text-align: center;
}

.permisos-alta-toggle-textos > .es-oculto {
    visibility: hidden;
}

.permisos-formulario .permisos-alta-toggle {
    flex: 0 0 auto;
    margin-top: -0.15rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.9rem;
    border: 1px solid var(--ink);
    border-radius: 4px;
    background: var(--ink);
    color: #fff;
    font-weight: 600;
    white-space: nowrap;
    transition: background-color 0.16s ease, color 0.16s ease;
}

.permisos-formulario .permisos-alta-toggle:hover {
    background: #121a2c;
    border-color: #121a2c;
    color: #fff;
}

.permisos-formulario .permisos-alta-toggle.abierta {
    background: #fff;
    color: var(--ink);
}

.permisos-formulario .permisos-alta-toggle.abierta:hover {
    background: var(--sheet);
    border-color: var(--ink);
    color: var(--ink);
}

.permisos-alta-toggle-icono {
    font-size: 0.8rem;
    transition: transform 0.2s ease;
}

.permisos-alta-toggle.abierta .permisos-alta-toggle-icono {
    transform: rotate(45deg);
}

/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */
.permisos-alta-panel {
    display: grid;
    grid-template-rows: 0fr;
    visibility: hidden;
    transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;
}

.permisos-alta-panel.abierta {
    grid-template-rows: 1fr;
    visibility: visible;
    transition: grid-template-rows 0.25s ease, visibility 0s;
}

.permisos-alta-panel-interior {
    min-height: 0;
    overflow: hidden;
}

.permisos-alta-panel .permisos-sheet {
    margin-bottom: 1.6rem;
}

.permisos-formulario #seccionCabecera p {
    text-align: left;
    padding-left: 0;
    margin-bottom: 0;
}

.permisos-title {
    display: block;
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: -0.03em;
    line-height: 1.05;
    color: var(--ink);
}

.permisos-title::after {
    content: "";
    display: block;
    width: 2.25rem;
    height: 3px;
    margin-top: 0.55rem;
    background: var(--senal);
}

.permisos-formulario #seccionCabecera .permisos-lead {
    max-width: 46rem;
    margin-top: 0.55rem;
    color: var(--soft);
    font-size: 0.95rem;
}

.permisos-sheet {
    background: var(--sheet);
    border: 1px solid var(--line);
    border-radius: 6px;
    padding: 1.1rem 1.2rem 1.05rem;
}

.permisos-bloque-titulo {
    margin: 0 0 0.7rem;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: var(--ink);
}

.permisos-label {
    display: block;
    margin-bottom: 0.3rem;
    color: var(--ink);
    font-size: 0.82rem;
    font-weight: 600;
}

.permisos-formulario .form-control {
    border-color: var(--field);
    border-radius: 4px;
    color: var(--ink);
}

.permisos-formulario .form-control:focus {
    border-color: var(--ink);
    box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}

.permisos-nota {
    margin: 0.75rem 0 0;
    color: var(--soft);
    font-size: 0.82rem;
}

.permisos-error {
    margin: 0.75rem 0 0;
    padding: 0.5rem 0.75rem;
    border-left: 3px solid var(--peligro);
    background: #fbf1f4;
    color: var(--peligro);
    font-size: 0.88rem;
}

.permisos-aviso {
    margin: 0.75rem 0 0;
    padding: 0.45rem 0.75rem;
    border-left: 3px solid var(--senal);
    background: #fff6ee;
    color: var(--ink);
    font-size: 0.85rem;
}

.permisos-vacio {
    margin: 0;
    color: var(--soft);
    font-size: 0.9rem;
}

/* Alta */

.permisos-alta {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem 1rem;
    align-items: end;
}

.permisos-alta-indicadores {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.6rem;
}

/* Interruptor: la misma pieza en el listado, el alta y la ficha */

.permisos-switch {
    position: relative;
    flex: 0 0 auto;
    display: inline-block;
    width: 2.15rem;
    height: 1.2rem;
    border-radius: 999px;
    background: #c9d2df;
    transition: background-color 0.16s ease;
}

.permisos-switch::after {
    content: "";
    position: absolute;
    top: 0.175rem;
    left: 0.175rem;
    width: 0.85rem;
    height: 0.85rem;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(27, 39, 64, 0.25);
    transition: transform 0.18s ease, background-color 0.16s ease;
}

[aria-checked="true"] > .permisos-switch {
    background: var(--senal);
}

[aria-checked="true"] > .permisos-switch::after {
    transform: translateX(0.95rem);
}

.permisos-switch-boton {
    display: inline-flex;
    padding: 0.35rem;
    border: 0;
    border-radius: 999px;
    background: transparent;
    cursor: pointer;
}

.permisos-switch-boton:focus-visible,
.permisos-toma:focus-visible,
.permisos-formulario .btn:focus-visible {
    outline: 2px solid var(--ink);
    outline-offset: 2px;
}

/* Toma: un interruptor con su nombre, para el alta y la ficha */

.permisos-toma {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
    min-height: 2.75rem;
    padding: 0.55rem 0.75rem;
    border: 1px solid var(--line);
    border-radius: 4px;
    background: #fff;
    color: var(--soft);
    text-align: left;
    cursor: pointer;
    transition: border-color 0.16s ease, box-shadow 0.16s ease, color 0.16s ease;
}

.permisos-toma:hover {
    border-color: var(--field);
    color: var(--ink);
}

.permisos-toma[aria-checked="true"] {
    border-color: var(--ink);
    box-shadow: inset 3px 0 0 var(--senal);
    color: var(--ink);
}

.permisos-toma-texto {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.permisos-toma-nombre {
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1.2;
}

.permisos-toma-ayuda {
    margin-top: 0.15rem;
    font-size: 0.78rem;
    line-height: 1.3;
    color: var(--soft);
}

.permisos-codigo {
    font-family: var(--mono);
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    color: var(--ink);
}

/* Listado */

.permisos-roster {
    margin-top: 0.4rem;
}

.permisos-roster-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.75rem 1.25rem;
    margin-bottom: 0.6rem;
}

.permisos-cuenta {
    margin: 0.2rem 0 0;
    color: var(--soft);
    font-size: 0.8rem;
}

.permisos-buscar {
    position: relative;
    width: min(100%, 20rem);
}

.permisos-buscar-icono {
    position: absolute;
    top: 50%;
    left: 0.7rem;
    transform: translateY(-50%);
    color: var(--field);
    font-size: 0.8rem;
    pointer-events: none;
}

.permisos-buscar .form-control {
    padding-left: 2rem;
}

.permisos-tabla-wrap {
    overflow-x: auto;
    border-top: 2px solid var(--ink);
}

.permisos-tabla {
    width: 100%;
    border-collapse: collapse;
}

.permisos-tabla thead th {
    padding: 0.55rem 0.6rem;
    border-bottom: 1px solid var(--line);
    color: var(--soft);
    font-size: 0.75rem;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
}

.permisos-tabla thead th.permisos-th-indicador {
    width: 8.5rem;
    text-align: center;
}

.permisos-tabla tbody tr {
    border-bottom: 1px solid var(--line);
    transition: background-color 0.12s ease;
}

.permisos-tabla tbody tr:hover {
    background: #f8fafc;
}

.permisos-tabla tbody tr.es-ficha {
    background: var(--sheet);
    box-shadow: inset 3px 0 0 var(--senal);
}

.permisos-tabla tbody th,
.permisos-tabla tbody td {
    padding: 0.4rem 0.6rem;
    vertical-align: middle;
}

.permisos-email {
    font-weight: 600;
    color: var(--ink);
    word-break: break-all;
}

.permisos-email-dominio {
    font-weight: 400;
    color: var(--soft);
}

.permisos-td-indicador {
    text-align: center;
}

.permisos-acciones {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.35rem;
    white-space: nowrap;
}

.permisos-nadie {
    padding: 1rem 0.6rem;
    color: var(--soft);
    font-size: 0.9rem;
}

/* Botones */

.permisos-formulario .permisos-commit {
    background: var(--ink);
    border-color: var(--ink);
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
}

.permisos-formulario .permisos-commit:hover:not(:disabled) {
    background: #121a2c;
    border-color: #121a2c;
    color: #fff;
}

.permisos-formulario .permisos-commit:disabled {
    background: #c5cedb;
    border-color: #c5cedb;
    color: #fff;
    opacity: 1;
}

.permisos-formulario .permisos-abrir {
    padding: 0.25rem 0.7rem;
    border: 1px solid #c5cedb;
    border-radius: 4px;
    background: transparent;
    color: var(--ink);
    font-size: 0.85rem;
    font-weight: 600;
}

.permisos-formulario .permisos-abrir:hover {
    background: var(--ink);
    border-color: var(--ink);
    color: #fff;
}

.permisos-formulario .permisos-borrar {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 4px;
    background: transparent;
    color: var(--peligro);
    font-size: 0.85rem;
}

.permisos-formulario .permisos-borrar:hover {
    background: var(--peligro);
    border-color: var(--peligro);
    color: #fff;
}

/* Ficha */

.permisos-modal-eyebrow {
    display: block;
    color: var(--soft);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.permisos-modal-email {
    display: block;
    margin-top: 0.2rem;
    color: var(--ink);
    font-size: 1.35rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    word-break: break-all;
}

.permisos-bloque + .permisos-bloque {
    margin-top: 1.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid var(--line);
}

.permisos-bloque-cabeza {
    margin-bottom: 0.75rem;
}

.permisos-bloque-nombre {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: var(--ink);
}

.permisos-bloque-ayuda {
    margin: 0.15rem 0 0;
    color: var(--soft);
    font-size: 0.85rem;
}

.permisos-dominios {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));
    gap: 0.6rem;
}

.permisos-origenes {
    margin: 0;
    padding: 0;
    list-style: none;
}

.permisos-origen {
    display: grid;
    grid-template-columns: minmax(5rem, 9rem) minmax(0, 1fr) 2.75rem minmax(0, 1fr);
    align-items: center;
    padding: 0.35rem 0;
}

.permisos-origen + .permisos-origen {
    border-top: 1px dashed var(--line);
}

/* Conector: une Enviar y Listas cuando las listas arrastran el envío */

.permisos-conector {
    height: 2px;
    background-image: linear-gradient(90deg, var(--line) 50%, transparent 50%);
    background-size: 6px 2px;
    transition: background 0.16s ease;
}

.con-envio .permisos-conector {
    background: var(--line);
}

.con-listas .permisos-conector {
    height: 3px;
    background: var(--senal);
}

.arrastre-previsto .permisos-conector {
    height: 3px;
    background-image: linear-gradient(90deg, var(--senal) 50%, transparent 50%);
    background-size: 8px 3px;
}

.permisos-toma.se-arrastra {
    border-style: dashed;
    border-color: var(--senal);
    background: #fff6ee;
    color: var(--ink);
}

.permisos-estado {
    flex: 1 1 auto;
    margin: 0;
    color: var(--soft);
    font-size: 0.85rem;
}

.permisos-estado.es-error {
    color: var(--peligro);
    font-weight: 600;
}

@media (max-width: 760px) {
    .permisos-page {
        padding-top: 0.85rem;
    }

    .permisos-sheet {
        padding: 0.95rem 0.85rem 0.9rem;
    }

    .permisos-title {
        font-size: 1.7rem;
    }

    .permisos-alta,
    .permisos-alta-indicadores {
        grid-template-columns: 1fr;
    }

    .permisos-alta-accion {
        order: 3;
    }

    .permisos-alta-accion .btn {
        width: 100%;
    }

    .permisos-roster-head {
        flex-direction: column;
        align-items: stretch;
    }

    .permisos-buscar {
        width: 100%;
    }

    .permisos-tabla thead {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
    }

    .permisos-tabla tbody tr {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 0.75rem 0.25rem;
    }

    .permisos-tabla tbody th,
    .permisos-tabla tbody td {
        display: block;
        padding: 0.2rem 0.35rem;
    }

    .permisos-tabla tbody th.permisos-email,
    .permisos-tabla tbody td.permisos-td-acciones,
    .permisos-tabla tbody td.permisos-nadie {
        grid-column: 1 / -1;
    }

    .permisos-td-indicador {
        text-align: left;
    }

    .permisos-td-indicador::before {
        content: attr(data-label);
        display: block;
        color: var(--soft);
        font-size: 0.72rem;
        font-weight: 600;
    }

    .permisos-switch-boton {
        padding-left: 0;
    }

    .permisos-acciones {
        justify-content: space-between;
        margin-top: 0.35rem;
    }

    .permisos-origen {
        grid-template-columns: 1fr 1fr;
        gap: 0.45rem 0.6rem;
        padding: 0.6rem 0;
    }

    .permisos-origen > .permisos-codigo {
        grid-column: 1 / -1;
    }

    .permisos-conector {
        display: none;
    }
}

@media (prefers-reduced-motion: reduce) {
    .permisos-alta-panel,
    .permisos-alta-panel.abierta,
    .permisos-alta-toggle,
    .permisos-alta-toggle-icono,
    .permisos-switch,
    .permisos-switch::after,
    .permisos-toma,
    .permisos-conector,
    .permisos-tabla tbody tr {
        transition: none;
    }
}
</style>

<style>
/* BModal se monta en body: sus piezas propias y las variables no heredan de la página. */
.permisos-modal {
    --ink: #1b2740;
    --soft: #5c6b86;
    --line: #d5deea;
    --field: #8b97ab;
    --sheet: #f3f6fa;
    --senal: #ff7900;
    --peligro: #9b1c3c;
    --mono: ui-monospace, "SFMono-Regular", "Cascadia Mono", Menlo, Consolas, monospace;
    color: var(--ink);
}

.permisos-modal .modal-content {
    border: 1px solid var(--line);
    border-top: 3px solid var(--senal);
    border-radius: 6px;
    box-shadow: 0 18px 48px rgba(27, 39, 64, 0.22);
}

.permisos-modal .modal-header {
    align-items: flex-start;
    padding: 1.1rem 1.35rem 0.9rem;
    border-bottom: 1px solid var(--line);
}

.permisos-modal .modal-title {
    min-width: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--ink);
}

.permisos-modal .modal-body {
    padding: 1.2rem 1.35rem 1.35rem;
}

.permisos-modal .modal-footer {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1.35rem;
    border-top: 1px solid var(--line);
    background: var(--sheet);
}

.permisos-modal .modal-footer > * {
    margin: 0;
}

.permisos-modal .modal-footer .btn {
    border-radius: 4px;
    font-weight: 600;
}

.permisos-modal .modal-footer .permisos-commit {
    background: var(--ink);
    border-color: var(--ink);
    color: #fff;
}

.permisos-modal .modal-footer .permisos-commit:hover {
    background: #121a2c;
    border-color: #121a2c;
}

.permisos-modal-peligro .modal-content {
    border-top-color: var(--peligro);
}

.permisos-modal .modal-footer .btn-danger {
    background: var(--peligro);
    border-color: var(--peligro);
    color: #fff;
}

.permisos-modal .modal-footer .btn-danger:hover {
    background: #7d1530;
    border-color: #7d1530;
}

.permisos-modal .modal-footer .btn:focus-visible {
    outline: 2px solid var(--ink);
    outline-offset: 2px;
}
</style>
